/* eslint-disable global-require */

// Important: can't use config.PROD because
// it's not imported before this check
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./configureStore.prod');
} else {
  module.exports = require('./configureStore.dev');
}
